export const TEXT_LOCALE_ZHCHT = {
    yes: 'æ¯',
    no: 'å¦',
    zoom: 'å¨æéçå°è©±æ¡ä¸­ç·¨è¼¯å§å®¹',
    comments: {
        title: 'å¸¸ç¨æè¦',
        manager: 'æè¦ç®¡ç',
        empty: 'æ«ç¡æ¸æ'
    }
};
